import { useEffect, useState } from 'react'
import createVersionStore from './versionStore'
import { countByStatus } from './repositories/asyncOps'
import { getQueueOwner } from './queueContext'

/**
 * Versi antrean transaksi. Di-bump setiap enqueue / upload / rekonsiliasi supaya
 * indikator (badge, riwayat) ikut ter-update, termasuk di tab lain.
 */
export const queueVersion = createVersionStore('kledo-pos-queue-version')

export const bumpQueueVersion = queueVersion.bump

export const useQueueVersion = queueVersion.useVersion

const EMPTY_COUNTS = { pending: 0, sent: 0, failed: 0, blocked: 0 }

/**
 * Jumlah op per status milik kasir aktif, ter-update saat versi antrean berubah.
 * `enabled: false` melewatkan query (DB tak dibuka) — pakai saat mode OFF.
 */
export const useAsyncQueueStatus = (enabled = true) => {
  const version = useQueueVersion()
  const [counts, setCounts] = useState(EMPTY_COUNTS)
  const owner = getQueueOwner()
  const ownerKey = owner ? `${owner.userId}@${owner.endpoint}` : ''

  useEffect(() => {
    if (!enabled || !ownerKey) {
      setCounts(EMPTY_COUNTS)
      return undefined
    }
    let alive = true
    countByStatus(getQueueOwner())
      .then((result) => {
        if (alive) {
          setCounts(result)
        }
      })
      .catch(() => {})
    return () => {
      alive = false
    }
  }, [version, enabled, ownerKey])

  return counts
}
